import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OrderSelectModal from "../common/OrderSelectModal";
import OutgoingSelectModal from "../common/OutgoingSelectModal";
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";
import { AssistWalkerTwoTone, CatchingPokemonSharp } from "@mui/icons-material";
import { IoMdReturnLeft } from "react-icons/io";

let newFileID = 1;
let realFiles = [];
function OutgoingRegModal({ title, onClose, handleRegSuccessSave, userTypeModalOption, qualityYnModalOption, MenuUpdateYN, payload}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    outgoing_id: null,
    outgoing_number: '',
    outgoing_date: appStore.YYYY_MM_DD(),
    outgoing_partner_id: 0,
    outgoing_partner_name: '',
    outgoing_partner_manager: '',
    outgoing_partner_manager_phone: '',
    outgoing_partner_manager_mail: '',
    outgoing_partner_delivery_post: '',
    outgoing_partner_delivery_address: '',
    outgoing_partner_delivery_address_add: '',
    outgoing_bigo: '',
    outgoing_order_id: null,
    outgoing_order_number: '',
    outgoing_ref_outgoing_id:null
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectOrderModalOpen, setSelectOrderModalOpen] = useState(false);
  const [isSelectOutgoingModalOpen, setSelectOutgoingModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_item_id', headerName: 'outgoing_item_id', headerAlign: 'center', align:'center' },
      { field: 'outgoing_item_name', headerName: '품목', width: 180, headerAlign: 'center', align:'left' },
      { field: 'outgoing_item_spec', headerName: '규격', width: 180, headerAlign: 'center', align:'left' },
      { field: 'outgoing_package_count', headerName: '수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'outgoing_pack_rate', headerName: '포장수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'outgoing_item_count', headerName: '출하수량', type: 'number', width: 90, headerAlign: 'center', align:'right', editable: false },
      { field: 'outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'outgoing_item_bigo', headerName: '비고', width: 230, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' }
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_id', headerName: 'lot_outgoing_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_outgoing_save_workplace_id', headerName: 'lot_outgoing_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_workplace_name', headerName: '사업장',width: 110, headerAlign: 'center'},
      { field: 'lot_outgoing_save_warehouse_id', headerName: 'lot_outgoing_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_outgoing_save_warehouse_name', headerName: '창고', width: 110, headerAlign: 'center', align:'left' },
      { field: 'lot_outgoing_save_section_id', headerName: 'lot_outgoing_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_outgoing_save_section_name', headerName: '구역',width: 110, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_id', headerName: 'outgoing_user_id', width: 0, headerAlign: 'center' },
      { field: 'outgoing_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'outgoing_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      outgoing_item_id: false,
      outgoing_item_name: true,
      outgoing_item_spec: true,
      outgoing_package_count: true,
      outgoing_pack_rate: true,
      outgoing_item_count: true,
      outgoing_quality_exam_yn: false,
      outgoing_item_bigo: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_outgoing_item_id: false,
      lot_outgoing_item_name: true,
      lot_outgoing_item_spec: true,
      lot_outgoing_quality_exam_yn: false,
      lot_outgoing_save_workplace_id: false,
      lot_outgoing_save_workplace_name: true,
      lot_outgoing_save_warehouse_id: false,
      lot_outgoing_save_warehouse_name: true,
      lot_outgoing_save_section_id: false,
      lot_outgoing_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: true,
      outgoing_user_id: false,
      outgoing_user_name: true,
      outgoing_user_dept_name: true,
      outgoing_user_position_name: true,
      outgoing_user_type: true,
      outgoing_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    outgoing_item_id: false,
    outgoing_item_name: true,
    outgoing_item_spec: true,
    outgoing_package_count: true,
    outgoing_pack_rate: true,
    outgoing_item_count: true,
    outgoing_quality_exam_yn: true,
    outgoing_item_bigo: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_outgoing_item_id: false,
    lot_outgoing_item_name: true,
    lot_outgoing_item_spec: true,
    lot_outgoing_quality_exam_yn: true,
    lot_outgoing_save_workplace_id: false,
    lot_outgoing_save_workplace_name: true,
    lot_outgoing_save_warehouse_id: false,
    lot_outgoing_save_warehouse_name: true,
    lot_outgoing_save_section_id: false,
    lot_outgoing_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    outgoing_user_id: false,
    outgoing_user_name: true,
    outgoing_user_dept_name: true,
    outgoing_user_position_name: true,
    outgoing_user_type: true,
    outgoing_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    if (payload && (payload.from === 'excel_upload' || payload.from === 'excel_dragdrop') && payload.uploadResult) {
      const data = payload.uploadResult;

      setInputs(prev => ({
        ...prev,
        outgoing_date: data.order_date || appStore.YYYY_MM_DD(),
        outgoing_partner_id: Number(data.partner_id) || 0,
        outgoing_partner_name: data.partner_name || '',
        outgoing_partner_manager: data.partner_manager || '',
        outgoing_partner_manager_phone: data.partner_manager_phone || '',
        outgoing_partner_manager_email: data.partner_manager_mail || '', 
        outgoing_partner_delivery_post: data.ship_zip || '',
        outgoing_partner_delivery_address: data.ship_addr || '',
        outgoing_partner_delivery_address_add: data.ship_addr_detail || '',
        outgoing_bigo: data.remark || '',
      }));

      if (data.items && data.items.length > 0) {
        const validItems = data.items.filter(it => it.item_id || it.item_name);
        
        const processOutgoingItems = async () => {
          let itemTempData = [];
          let itemLotCount = 0;

          for (let i = 0; i < validItems.length; i++) {
            const it = validItems[i];
            const qty = Number(it.qty) || 0;
            
            const tempData = {
              id: i + 1,
              outgoing_item_id: it.item_id || '',
              outgoing_item_name: it.item_name || '', 
              outgoing_item_spec: it.item_spec || '', 
              outgoing_package_count: qty,
              outgoing_pack_rate: 1, // 일단 1
              outgoing_item_count: qty * 1,
              outgoing_quality_exam_yn: 'N',
              outgoing_item_bigo: it.extra_info || '', 
              row_type: 'A',
              update_type: 'U'
            };
            
            itemTempData.push(tempData);

            if (tempData.outgoing_item_id && qty > 0) {
              const return_data = await searchLotRow(tempData, 'A', itemLotCount);
              itemLotCount = itemLotCount + qty;

              if (!return_data) {
                tempData.outgoing_item_count = 0;
                tempData.outgoing_package_count = 0;
              }
            }
          }

          setItemRows(itemTempData);
          setUpdateItemRows(itemTempData);
        };

        processOutgoingItems();
      }

      if (data.users && data.users.length > 0) {
        const validUsers = data.users.filter(u => u.user_id || u.user_name);
        const parsedUsers = validUsers.map((u, idx) => ({
          id: idx + 1,
          outgoing_user_id: u.user_id || '',
          outgoing_user_name: u.user_name || '',
          outgoing_user_type: Number(u.user_type_id) || 0,
          outgoing_user_dept_name: u.user_dept_name || '',
          outgoing_user_position_name: u.user_position_name || '',
          outgoing_user_bigo: u.remark || '',
          row_type: 'A',
          update_type: 'U'
        }));
        setUserRows(parsedUsers);
        setUpdateUserRows(parsedUsers);
      }
    }
  }, [payload]);

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_package_count: '',
        outgoing_pack_rate: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoing_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; 
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ 
    setSelectModalTitle('출하처 목록')
    setSelectPartnerModalOpen(true);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'outgoing_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.outgoing_package_count > 99999 || newRow.outgoing_pack_rate > 99999){
      return;
    }

    let newUpdateDataArray = {}
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
    
    if(newRow.outgoing_item_id !== oldRow.outgoing_item_id || newRow.outgoing_item_name !== oldRow.outgoing_item_name 
      || newRow.outgoing_package_count !== oldRow.outgoing_package_count || newRow.outgoing_pack_rate !== oldRow.outgoing_pack_rate
      || newRow.outgoing_quality_exam_yn !== oldRow.outgoing_quality_exam_yn || newRow.outgoing_item_bigo !== oldRow.outgoing_item_bigo){
      
      // ▼ 수량 혹은 포장이 변경된 경우 총수량 재계산
      if (newRow.outgoing_package_count !== oldRow.outgoing_package_count || newRow.outgoing_pack_rate !== oldRow.outgoing_pack_rate){
        const pkgCount = Number(newRow.outgoing_package_count || 0);
        const packRate = Number(newRow.outgoing_pack_rate || 1);
        newUpdateDataArray = { 
          ...newRow
          , ['outgoing_item_count']: pkgCount * packRate
          , update_type: 'U' }; 
      } else {
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }

      var row_outgoing_item_id = '';
      var row_outgoing_item_name = '';
      var row_outgoing_item_spec = '';
      var row_outgoing_package_count = '';
      var row_outgoing_pack_rate = '';
      var row_outgoing_item_count = '';
      var row_outgoing_quality_exam_yn = 'N';
      var row_outgoing_item_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.outgoing_item_id !== '' || newRow.outgoing_item_name !== '' || newRow.outgoing_item_spec !== '' || newRow.outgoing_package_count !== '' || newRow.outgoing_pack_rate !== '' || newRow.outgoing_item_bigo !== '' || newRow.outgoing_quality_exam_yn !== 'N'){
          row_outgoing_item_id = newRow.outgoing_item_id;
          row_outgoing_item_name = newRow.outgoing_item_name;
          row_outgoing_item_spec = newRow.outgoing_item_spec;
          row_outgoing_package_count = newRow.outgoing_package_count;
          row_outgoing_pack_rate = newRow.outgoing_pack_rate;
          row_outgoing_item_count = newRow.outgoing_item_count;
          row_outgoing_quality_exam_yn = newRow.outgoing_quality_exam_yn;
          row_outgoing_item_bigo = newRow.outgoing_item_bigo;
        }
      }else{
        itemRows.map((data) => data.id === newRow.id 
          && (data.outgoing_item_id !== newRow.outgoing_item_id || data.outgoing_item_name !== newRow.outgoing_item_name || data.outgoing_item_spec !== newRow.outgoing_item_spec || data.outgoing_package_count !== newRow.outgoing_package_count || data.outgoing_pack_rate !== newRow.outgoing_pack_rate || data.outgoing_quality_exam_yn !== newRow.outgoing_quality_exam_yn || data.outgoing_item_bigo !== newRow.outgoing_item_bigo)?
          (
            row_outgoing_item_id = data.outgoing_item_id,
            row_outgoing_item_name = data.outgoing_item_name,
            row_outgoing_item_spec = data.outgoing_item_spec,
            row_outgoing_package_count = data.outgoing_package_count,
            row_outgoing_pack_rate = data.outgoing_pack_rate,
            row_outgoing_item_count = data.outgoing_item_count,
            row_outgoing_quality_exam_yn = data.outgoing_quality_exam_yn,
            row_outgoing_item_bigo = data.outgoing_item_bigo
          ):""
        )
      }
      
      if(row_outgoing_item_id === '' && row_outgoing_item_name === '' && row_outgoing_item_spec === '' && row_outgoing_package_count === '' && row_outgoing_pack_rate === '' && row_outgoing_quality_exam_yn === 'N' && row_outgoing_item_bigo === ''){
        if(updateItemRows.length > 0){
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          searchLotRow(newNoDataArray, 'O');
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }
        
        if(updateRowsYN === 'Y'){
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(newUpdateDataArray, 'A');
        }else{
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          searchLotRow(newUpdateDataArray, 'A');
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const searchLotRow = async (tempNewUpdateData, tempType, startCount = 0) => { 
    if(tempNewUpdateData.outgoing_item_count === null || tempNewUpdateData.outgoing_item_count === ''){
      tempNewUpdateData.outgoing_item_count = 0
      tempType = 'D'
    }

    if(tempType === 'D'){ 
      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'O'){ 
      setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows((updateLotRows) => updateLotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));

    } else if(tempType === 'A'){ 
      if(typeof itemRows.find((data) => data.id === tempNewUpdateData.id) !== 'undefined' && (tempNewUpdateData.outgoing_item_count === 0 || tempNewUpdateData.outgoing_item_count === '' || tempNewUpdateData.outgoing_item_count === null)){
      }else if(tempNewUpdateData.outgoing_item_count < 0){
        Swal.fire({
          title: '<p style="color:red">출하 수량 오류</p>',
          text: '출하 수량은 음수가 될 수 없습니다.',
          confirmButtonText: '확인'
        });

        processItemRowUpdate(
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_package_count: tempNewUpdateData.outgoing_package_count,
            outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
            outgoing_item_count: '',
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          },
          {
            id: tempNewUpdateData.id,
            outgoing_item_id: tempNewUpdateData.outgoing_item_id,
            outgoing_item_name: tempNewUpdateData.outgoing_item_name,
            outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
            outgoing_package_count: tempNewUpdateData.outgoing_package_count,
            outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
            outgoing_item_count: tempNewUpdateData.outgoing_item_count,
            outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
            outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
            row_type:tempNewUpdateData.row_type,
            update_type: tempNewUpdateData.update_type,
          }
        )
        return false;
      }else{
        if(tempNewUpdateData.outgoing_item_id == '' || tempNewUpdateData.outgoing_item_count == '' || tempNewUpdateData.outgoing_item_count == '0'){
          return;
        }

        setLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
        setUpdateLotRows((lotRows) => lotRows.filter((data) => data.upper_id !== tempNewUpdateData.id));
        
        return axios.get('/api/Common/StockFIFOInfo',
            {
            params : {
                item_id : tempNewUpdateData.outgoing_item_id,
                item_count: tempNewUpdateData.outgoing_item_count
            }
          },
          { withCredentials: true })
        .then((response) => {
          var start_lot_id = Number(appStore.getMaxListID(lotRows))+1+startCount;
          var create_lot_array = [];
          var lot_array = response.data;
          
          if(lot_array.length >= Number(tempNewUpdateData.outgoing_item_count)){
            for(var i=0; i<Number(tempNewUpdateData.outgoing_item_count); i++){
              create_lot_array.push(
                {
                  id: (start_lot_id+i),
                  upper_id :tempNewUpdateData.id,
                  lot_no: lot_array[i].item_lotno,
                  lot_outgoing_item_id : tempNewUpdateData.outgoing_item_id,
                  lot_outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                  lot_outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                  lot_outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                  lot_outgoing_save_workplace_id: (typeof lot_array[i].item_lot_save_workplace_id === 'undefined'?null:lot_array[i].item_lot_save_workplace_id),
                  lot_outgoing_save_workplace_name: (typeof lot_array[i].item_lot_save_workplace_name === 'undefined'?null:lot_array[i].item_lot_save_workplace_name),
                  lot_outgoing_save_warehouse_id: (typeof lot_array[i].item_lot_save_warehouse_id === 'undefined'?null:lot_array[i].item_lot_save_warehouse_id),
                  lot_outgoing_save_warehouse_name: (typeof lot_array[i].item_lot_save_warehouse_name === 'undefined'?null:lot_array[i].item_lot_save_warehouse_name),
                  lot_outgoing_save_section_id: (typeof lot_array[i].item_lot_save_section_id === 'undefined'?null:lot_array[i].item_lot_save_section_id),
                  lot_outgoing_save_section_name: (typeof lot_array[i].item_lot_save_section_name === 'undefined'?null:lot_array[i].item_lot_save_section_name),
                  row_type: 'A',
                  update_type: 'U'
                }
              )
            }
            setLotRows((lotRows) => [...lotRows, ...create_lot_array ]);
            setUpdateLotRows((updateLotRows) => [...updateLotRows, ...create_lot_array ]);
            return true;
          }else{
            Swal.fire({
              title: '<p style="color:red">출하 품목 재고 부족</p>',
              text: '품목의 가용 재고가 ' + (String(lot_array.length)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' 입니다.',
              confirmButtonText: '확인'
            });
            
            processItemRowUpdate(
              {
                id: tempNewUpdateData.id,
                outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                outgoing_package_count: '',
                outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
                outgoing_item_count: '',
                outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                row_type:tempNewUpdateData.row_type,
                update_type: tempNewUpdateData.update_type,
              },
              {
                id: tempNewUpdateData.id,
                outgoing_item_id: tempNewUpdateData.outgoing_item_id,
                outgoing_item_name: tempNewUpdateData.outgoing_item_name,
                outgoing_item_spec: tempNewUpdateData.outgoing_item_spec,
                outgoing_package_count: tempNewUpdateData.outgoing_package_count,
                outgoing_pack_rate: tempNewUpdateData.outgoing_pack_rate,
                outgoing_item_count: tempNewUpdateData.outgoing_item_count,
                outgoing_quality_exam_yn: tempNewUpdateData.outgoing_quality_exam_yn,
                outgoing_item_bigo: tempNewUpdateData.outgoing_item_bigo,
                row_type:tempNewUpdateData.row_type,
                update_type: tempNewUpdateData.update_type,
              }
            )
            return false;
          }
        });
      }
    }
    return true;
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 
    
    if(newRow.lot_no !== oldRow.lot_no && newRow.lot_outgoing_item_id !== oldRow.lot_outgoing_item_id && newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
      var row_lot_no = '';
      var row_lot_outgoing_quality_exam_yn = 'N';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.lot_no !== oldRow.lot_no || newRow.lot_outgoing_quality_exam_yn !== oldRow.lot_outgoing_quality_exam_yn){
          row_lot_no = newRow.lot_no;
          row_lot_outgoing_quality_exam_yn = newRow.lot_outgoing_quality_exam_yn;
        }
      }else{
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_no !== newRow.lot_no || data.lot_outgoing_quality_exam_yn !== newRow.lot_outgoing_quality_exam_yn)?
          (
            row_lot_no = data.lot_no,
            row_lot_outgoing_quality_exam_yn = data.row_lot_outgoing_quality_exam_yn
          ):""
        )
      }
      
      if(row_lot_no === '' && row_lot_outgoing_quality_exam_yn === 'N'){
        if(updateLotRows.length > 0){
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 
    
    if(oldRow.outgoing_user_id !== newRow.outgoing_user_id || oldRow.outgoing_user_type !== newRow.outgoing_user_type || oldRow.outgoing_user_bigo !== newRow.outgoing_user_bigo){
      var row_outgoing_user_id = '';
      var row_outgoing_user_name = '';
      var row_outgoing_user_type = '';
      var row_outgoing_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.outgoing_user_id !== '' || newRow.outgoing_user_name !== '' || (newRow.outgoing_user_type !== '' && newRow.outgoing_user_type !== null) || newRow.outgoing_user_bigo !== '' ){
          row_outgoing_user_id = newRow.outgoing_user_id;
          row_outgoing_user_name = newRow.outgoing_user_name;
          row_outgoing_user_type = newRow.outgoing_user_type;
          row_outgoing_user_bigo = newRow.outgoing_user_bigo;
        }
      }else{
        userRows.map((data) => data.id === newRow.id 
          && (data.outgoing_user_id !== newRow.outgoing_user_id || data.outgoing_user_name !== newRow.outgoing_user_name || data.outgoing_user_type !== newRow.outgoing_user_type || data.outgoing_user_bigo !== newRow.outgoing_user_bigo )?
          (
            row_outgoing_user_id = data.outgoing_user_id,
            row_outgoing_user_name = data.outgoing_user_name,
            row_outgoing_user_type = data.outgoing_user_type,
            row_outgoing_user_bigo = data.outgoing_user_bigo
          ):""
        )
      }
      
      if(row_outgoing_user_id === '' && row_outgoing_user_name === '' && row_outgoing_user_bigo === '' && (row_outgoing_user_type === '' || row_outgoing_user_type === null)){
        if(updateUserRows.length > 0){
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        outgoing_item_id: '',
        outgoing_item_name: '',
        outgoing_item_spec: '',
        outgoing_package_count: '',
        outgoing_pack_rate: '',
        outgoing_item_count: '',
        outgoing_quality_exam_yn: 'N',
        outgoing_item_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        outgoing_item_id: object.row.outgoing_item_id,
        outgoing_item_name: object.row.outgoing_item_name,
        outgoing_item_spec: object.row.outgoing_item_spec,
        outgoing_package_count: object.row.outgoing_package_count,
        outgoing_pack_rate: object.row.outgoing_pack_rate,
        outgoing_item_count: object.row.outgoing_item_count,
        outgoing_quality_exam_yn: object.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: object.row.outgoing_item_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    searchLotRow(object.row, 'D')
  };

  const userAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        outgoing_user_id: '',
        outgoing_user_name: '',
        outgoing_user_dept_name: '',
        outgoing_user_position_name: '',
        outgoing_user_type: '',
        outgoing_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        outgoing_user_id: object.row.outgoing_user_id,
        outgoing_user_name: object.row.outgoing_user_name,
        outgoing_user_dept_name: object.row.outgoing_user_dept_name,
        outgoing_user_position_name: object.row.outgoing_user_position_name,
        outgoing_user_type: object.row.outgoing_user_type,
        outgoing_user_bigo: object.row.outgoing_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
  };

  const handleOrderRef = (event) => {
    setSelectModalTitle('수주 목록')
    setSelectOrderModalOpen(true);
  }

  const handleOutgoingRef = (event) => {
    setSelectModalTitle('출하 목록')
    setSelectOutgoingModalOpen(true);
  }

  const handleOrderClick = (object) => {
    if(object.length !== 0){
      Swal.fire({
        title: '수주번호 '+object[0].order_number+' 출하 등록',
        text: '확인버튼을 클릭하면 수주정보와 연결됩니다.',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(async result => {
        if (result.isConfirmed) {
          setLotRows([]);
          setUpdateLotRows([]);

          setInputs({
            outgoing_id: null,
            outgoing_number: '',
            outgoing_date: appStore.YYYY_MM_DD(),
            outgoing_partner_id: Number(object[0].order_partner_id),
            outgoing_partner_name: object[0].order_partner_name,
            outgoing_partner_manager: object[0].order_partner_manager,
            outgoing_partner_manager_phone: object[0].order_partner_manager_phone,
            outgoing_partner_manager_mail: object[0].order_partner_manager_mail,
            outgoing_partner_delivery_post: object[0].order_partner_delivery_post,
            outgoing_partner_delivery_address: object[0].order_partner_delivery_address,
            outgoing_partner_delivery_address_add: object[0].order_partner_delivery_address_add,
            outgoing_bigo: object[0].order_bigo,
            outgoing_order_id: Number(object[0].order_id),
            outgoing_order_number: object[0].order_number,
            outgoing_ref_outgoing_id: null,
          });
          
          var itemData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.order_item_seq !== 'undefined' && item.order_item_seq === item2.order_item_seq;
              }) === index
            );
          });

          var itemTempData = [];
          var itemLotCount = 0;
          for(let i = 0; i < itemData.length; i++){ 
            var tempData = {
              id: itemData[i].order_item_seq,
              outgoing_item_id: itemData[i].order_item_id,
              outgoing_item_name: itemData[i].order_item_name,
              outgoing_item_spec: itemData[i].order_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(itemData[i].order_item_spec, itemData[i].order_item_width, itemData[i].order_item_depth, itemData[i].order_item_height),
              outgoing_package_count: itemData[i].order_package_count,
              outgoing_pack_rate: itemData[i].order_pack_rate,
              outgoing_item_count: itemData[i].order_item_count,
              outgoing_quality_exam_yn: 'N',
              outgoing_item_bigo: '',
              row_type: 'A',
              update_type: 'U'
            }
            itemTempData = itemTempData.concat(tempData);
            var return_data = await searchLotRow(tempData, 'A', itemLotCount);
            itemLotCount = itemLotCount + Number(itemData[i].order_item_count);

            if(!return_data){
              itemData[i].order_item_count = 0;
              itemData[i].order_package_count = 0;
            }
          }
          
          setItemRows(itemData.map((item, index) => ({
            id: item.order_item_seq,
            outgoing_item_id: item.order_item_id,
            outgoing_item_name: item.order_item_name,
            outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.order_item_spec, item.order_item_width, item.order_item_depth, item.order_item_height),
            outgoing_package_count: item.order_package_count,
            outgoing_pack_rate: item.order_pack_rate,
            outgoing_item_count: item.order_item_count,
            outgoing_quality_exam_yn: 'N',
            outgoing_item_bigo: '',
            row_type: 'A',
            update_type: 'U'
          })));

          setUpdateItemRows(itemData.map((item, index) => ({
            id: item.order_item_seq,
            outgoing_item_id: item.order_item_id,
            outgoing_item_name: item.order_item_name,
            outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.order_item_spec, item.order_item_width, item.order_item_depth, item.order_item_height),
            outgoing_package_count: item.order_package_count,
            outgoing_pack_rate: item.order_pack_rate,
            outgoing_item_count: item.order_item_count,
            outgoing_quality_exam_yn: 'N',
            outgoing_item_bigo: '',
            row_type: 'A',
            update_type: 'U'
          })));

          var userData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.order_user_seq !== 'undefined' && item.order_user_seq === item2.order_user_seq;
              }) === index
            );
          });

          setUserRows(userData.map((item, index) => ({
            id: item.order_user_seq,
            outgoing_user_id: item.order_user_id,
            outgoing_user_name: item.order_user_name,
            outgoing_user_dept_name: item.order_user_dept_name,
            outgoing_user_position_name: item.order_user_position_name,
            outgoing_user_type: item.order_user_type,
            outgoing_user_bigo: item.order_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

          setUpdateUserRows(userData.map((item, index) => ({
            id: item.order_user_seq,
            outgoing_user_id: item.order_user_id,
            outgoing_user_name: item.order_user_name,
            outgoing_user_dept_name: item.order_user_dept_name,
            outgoing_user_position_name: item.order_user_position_name,
            outgoing_user_type: item.order_user_type,
            outgoing_user_bigo: item.order_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

        } else if (result.isDismissed) {
          const nextInputs = {
              ...inputs,
              ["outgoing_order_id"]: null,
              ["outgoing_order_number"]: ''
          };
          setInputs(nextInputs);
          
        }
      })
    }else{
      setInputs({
        outgoing_id: null,
        outgoing_number: '',
        outgoing_date: appStore.YYYY_MM_DD(),
        outgoing_partner_id: 0,
        outgoing_partner_name: '',
        outgoing_partner_manager: '',
        outgoing_partner_manager_phone: '',
        outgoing_partner_manager_mail: '',
        outgoing_partner_delivery_post: '',
        outgoing_partner_delivery_address: '',
        outgoing_partner_delivery_address_add: '',
        outgoing_bigo: '',
        outgoing_order_id: null,
        outgoing_order_number: '',
        outgoing_ref_outgoing_id: null,
      });

      setItemRows([]);
      setUpdateItemRows([]);
      setLotRows([]);
      setUpdateLotRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  }

  const handleOutgoingClick = (object) => {
    if(object.length !== 0){
      Swal.fire({
        title: '출하번호 '+object[0].outgoing_number+' 복사',
        text: '확인버튼을 클릭하면 출하정보가 복사됩니다.',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          setLotRows([]);
          setUpdateLotRows([]);
          setInputs({
            outgoing_id: null,
            outgoing_number: '',
            outgoing_date: appStore.YYYY_MM_DD(),
            outgoing_partner_id: Number(object[0].outgoing_partner_id),
            outgoing_partner_name: object[0].outgoing_partner_name,
            outgoing_partner_manager: object[0].outgoing_partner_manager,
            outgoing_partner_manager_phone: object[0].outgoing_partner_manager_phone,
            outgoing_partner_manager_mail: object[0].outgoing_partner_manager_mail,
            outgoing_partner_delivery_post: object[0].outgoing_partner_delivery_post,
            outgoing_partner_delivery_address: object[0].outgoing_partner_delivery_address,
            outgoing_partner_delivery_address_add: object[0].outgoing_partner_delivery_address_add,
            outgoing_bigo: object[0].outgoing_bigo,
            outgoing_order_id: null,
            outgoing_ref_outgoing_id: Number(object[0].outgoing_id),
          });
      
          var itemData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.outgoing_item_seq !== 'undefined' && item.outgoing_item_seq === item2.outgoing_item_seq;
              }) === index
            );
          });
      
          setItemRows(itemData.map((item, index) => ({
            id: item.outgoing_item_seq,
            outgoing_item_id: item.outgoing_item_id,
            outgoing_item_name: item.outgoing_item_name,
            outgoing_item_spec: item.outgoing_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.outgoing_item_spec, item.outgoing_item_width, item.outgoing_item_depth, item.outgoing_item_height),
            outgoing_package_count: item.outgoing_package_count,
            outgoing_pack_rate: item.outgoing_pack_rate,
            outgoing_item_count: item.outgoing_item_count,
            outgoing_quality_exam_yn: item.outgoing_quality_exam_yn,
            outgoing_item_bigo: item.outgoing_item_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

          var itemTempData = [];
          var itemLotCount = 0;
          for(let i = 0; i < itemData.length; i++){ 
            var tempData = {
              id: itemData[i].outgoing_item_seq,
              outgoing_item_id: itemData[i].outgoing_item_id,
              outgoing_item_name: itemData[i].outgoing_item_name,
              outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(itemData[i].outgoing_item_spec, itemData[i].outgoing_item_width, itemData[i].outgoing_item_depth, itemData[i].outgoing_item_height),
              outgoing_quality_exam_yn: itemData[i].outgoing_quality_exam_yn,
              outgoing_package_count: itemData[i].outgoing_package_count,
              outgoing_pack_rate: itemData[i].outgoing_pack_rate,
              outgoing_item_count: itemData[i].outgoing_item_count,
              row_type: 'A',
              update_type: 'U'
            }
            itemTempData = itemTempData.concat(tempData);
            searchLotRow(tempData, 'A', itemLotCount);
            itemLotCount = itemLotCount + Number(itemData[i].outgoing_item_count);
          }

          setUpdateItemRows(itemData.map((item, index) => ({
            id: item.outgoing_item_seq,
            outgoing_item_id: item.outgoing_item_id,
            outgoing_item_name: item.outgoing_item_name,
            outgoing_item_spec: item.outgoing_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.outgoing_item_spec, item.outgoing_item_width, item.outgoing_item_depth, item.outgoing_item_height),
            outgoing_package_count: item.outgoing_package_count,
            outgoing_pack_rate: item.outgoing_pack_rate,
            outgoing_item_count: item.outgoing_item_count,
            outgoing_quality_exam_yn: item.outgoing_quality_exam_yn,
            outgoing_item_bigo: item.outgoing_item_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

          var userData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.outgoing_user_seq !== 'undefined' && item.outgoing_user_seq === item2.outgoing_user_seq;
              }) === index
            );
          });

          setUserRows(userData.map((item, index) => ({
            id: item.outgoing_user_seq,
            outgoing_user_id: item.outgoing_user_id,
            outgoing_user_name: item.outgoing_user_name,
            outgoing_user_dept_name: item.outgoing_user_dept_name,
            outgoing_user_position_name: item.outgoing_user_position_name,
            outgoing_user_type: item.outgoing_user_type,
            outgoing_user_bigo: item.outgoing_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

          setUpdateUserRows(userData.map((item, index) => ({
            id: item.outgoing_user_seq,
            outgoing_user_id: item.outgoing_user_id,
            outgoing_user_name: item.outgoing_user_name,
            outgoing_user_dept_name: item.outgoing_user_dept_name,
            outgoing_user_position_name: item.outgoing_user_position_name,
            outgoing_user_type: item.outgoing_user_type,
            outgoing_user_bigo: item.outgoing_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

        } else if (result.isDismissed) {
          const nextInputs = {
              ...inputs,
              ["outgoing_ref_outgoing_id"]: null,
          };
          setInputs(nextInputs);
        }
      })
    }else{
      setInputs({
        outgoing_id: null,
        outgoing_number: '',
        outgoing_date: appStore.YYYY_MM_DD(),
        outgoing_partner_id: 0,
        outgoing_partner_name: '',
        outgoing_partner_manager: '',
        outgoing_partner_manager_phone: '',
        outgoing_partner_manager_mail: '',
        outgoing_partner_delivery_post: '',
        outgoing_partner_delivery_address: '',
        outgoing_partner_delivery_address_add: '',
        outgoing_bigo: '',
        outgoing_order_id: null,
        outgoing_order_number: '',
        outgoing_ref_outgoing_id: null,
      });

      setItemRows([]);
      setUpdateItemRows([]);
      setLotRows([]);
      setUpdateLotRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'outgoing_item_name' || params.field === 'outgoing_item_spec' ){
      setSelectModalTitle('품목 목록');
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        outgoing_item_id: params.row.outgoing_item_id,
        outgoing_item_name: params.row.outgoing_item_name,
        outgoing_item_spec: params.row.outgoing_item_spec,
        outgoing_package_count: params.row.outgoing_package_count,
        outgoing_pack_rate: params.row.outgoing_pack_rate,
        outgoing_item_count: params.row.outgoing_item_count,
        outgoing_quality_exam_yn: params.row.outgoing_quality_exam_yn,
        outgoing_item_bigo: params.row.outgoing_item_bigo,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'outgoing_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        outgoing_user_id: params.row.outgoing_user_id,
        outgoing_user_name: params.row.outgoing_user_name,
        outgoing_user_dept_name: params.row.outgoing_user_dept_name,
        outgoing_user_position_name: params.row.outgoing_user_position_name,
        outgoing_user_type: params.row.outgoing_user_type,
        outgoing_user_bigo: params.row.outgoing_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email
    var partner_delivery_post = object.partner_head_address_post === undefined?'':object.partner_head_address_post
    var partner_delivery_address = object.partner_head_address === undefined?'':object.partner_head_address
    var partner_delivery_address_add = object.partner_head_address_addition === undefined?'':object.partner_head_address_addition

    const nextInputs = {
        ...inputs,
        ["outgoing_partner_id"]: object.id,
        ["outgoing_partner_name"]: object.partner_name,
        ["outgoing_partner_manager"]: partner_user_name,
        ["outgoing_partner_manager_phone"]: partner_user_phone,
        ["outgoing_partner_manager_mail"]: partner_user_email,
        ["outgoing_partner_delivery_post"]: partner_delivery_post,
        ["outgoing_partner_delivery_address"]: partner_delivery_address,
        ["outgoing_partner_delivery_address_add"]: partner_delivery_address_add,
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].outgoing_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.outgoing_item_id){
        if (object.id === '') {
          processItemRowUpdate({
            id: selectItemData.id, outgoing_item_id: '', outgoing_item_name: '', outgoing_item_spec: '', outgoing_package_count: '', outgoing_pack_rate: '', outgoing_item_count: '',
            outgoing_quality_exam_yn: 'N', outgoing_item_bigo: '',
            row_type: selectItemData.row_type, update_type: selectItemData.update_type,
          }, { ...selectItemData });
        } else {
          processItemRowUpdate(
            {
              id: selectItemData.id,
              outgoing_item_id: object.id,
              outgoing_item_name: object.item_name,
              outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
              outgoing_package_count: selectItemData.outgoing_package_count,
              outgoing_pack_rate: object.item_outgoing_package_count || 1, // 품목 마스터의 출하포장비율 맵핑
              outgoing_item_count: Number(selectItemData.outgoing_package_count || 0) * Number(object.item_outgoing_package_count || 1),
              outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
              outgoing_item_bigo: selectItemData.outgoing_item_bigo,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              outgoing_item_id: selectItemData.outgoing_item_id,
              outgoing_item_name: selectItemData.outgoing_item_name,
              outgoing_item_spec: selectItemData.outgoing_item_spec,
              outgoing_package_count: selectItemData.outgoing_package_count,
              outgoing_pack_rate: selectItemData.outgoing_pack_rate,
              outgoing_item_count: selectItemData.outgoing_item_count,
              outgoing_quality_exam_yn: selectItemData.outgoing_quality_exam_yn,
              outgoing_item_bigo: selectItemData.outgoing_item_bigo,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    }
  };

  const handleUserClick = (object) => {
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].outgoing_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            outgoing_user_id: object.id,
            outgoing_user_name: object.user_name,
            outgoing_user_dept_name: object.dept_name,
            outgoing_user_position_name: object.position_name,
            outgoing_user_type: (selectUserData.outgoing_user_type === 0 || selectUserData.outgoing_user_type === '') ? 178 : selectUserData.outgoing_user_type,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            outgoing_user_id: selectUserData.outgoing_user_id,
            outgoing_user_name: selectUserData.outgoing_user_name,
            outgoing_user_type: (selectUserData.outgoing_user_type === 0 || selectUserData.outgoing_user_type === '') ? 178 : selectUserData.outgoing_user_type,
            outgoing_user_dept_name: selectUserData.outgoing_user_dept_name,
            outgoing_user_position_name: selectUserData.outgoing_user_position_name,
            outgoing_user_bigo: selectUserData.outgoing_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if(inputs.outgoing_partner_id === 0 || inputs.outgoing_partner_id === ''){
      msg = '출하처는 필수 선택 입니다.'
    }else if((inputs.outgoing_date) === '' || (inputs.outgoing_date) < '2025-01-01' || (inputs.outgoing_date).length != 10){
      msg = '출하일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.outgoing_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.outgoing_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.outgoing_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.outgoing_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(updateItemRows.length === 0){ 
      msg = '출하 품목이 존재하지 않습니다.';
    } else if(updateItemRows.length > 0 && msg === ''){ 
      for(let i = 0; i < updateItemRows.length; i++) {
        const outgoing_item_id = updateItemRows[i].outgoing_item_id;
        const outgoing_package_count = updateItemRows[i].outgoing_package_count;

        if(outgoing_item_id === 0 || outgoing_item_id === '') {
          msg = '선택되지 않는 출하 품목이 존재합니다.';
          break;
        }
        if(outgoing_package_count === 0 || outgoing_package_count === '' || outgoing_package_count === null) {
          msg = '입력되지 않는 수량이 존재합니다.';
          break;
        }
        if(outgoing_package_count < 0) {
          msg = '수량은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const outgoing_user_id = updateUserRows[i].outgoing_user_id;
        const outgoing_user_type = updateUserRows[i].outgoing_user_type;
        
        if(outgoing_user_id === 0 || outgoing_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(outgoing_user_type === 0 || outgoing_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">출하 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Outgoing/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = response.data;
          if(String(selectID) === '-1'){
            Swal.fire({
              title: '<p style="color:red">출하 LotNo 변경 발생</p>',
              text: '출하 등록할 LotNo의 변경이 발생했습니다.',
              confirmButtonText: '확인'
            });
          }else{
            if(updateFileRows.length > 0) {

              const formData = new FormData();
              formData.append('selectID', selectID);
              formData.append('folder', 'Outgoing');
              formData.append('type', 'Reg');
              formData.append('updateFileRows', JSON.stringify(updateFileRows));
              
              for(var i=0; i<realFiles.length; i++){            
                formData.append('files', realFiles[i]);
              }
              
              axios.post('/api/SaveCommon/GridFileSave'
                  , formData
                  , { headers: { 'Content-Type': 'multipart/form-data' } 
              }).then(response => {
                handleRegSuccessSave(selectID);
              }).catch(error => {
                appStore.capture();
              });
  
            }else{
              handleRegSuccessSave(selectID);
            }
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="출하 정보" value="1" />
                <Tab label="출하 품목" value="2" />
                <Tab label="출하 Lot" value="3" />
                <Tab label="출하 담당자" value="4" />
                <Tab label="출하 파일" value="5" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="출하번호" value={inputs.outgoing_number} name="outgoing_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">수주번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="수주번호" value={inputs.outgoing_order_number} name="outgoing_order_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="출하일자" value={inputs.outgoing_date} name="outgoing_date" onChange={(e) => onDateChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="출하처" value={inputs.outgoing_partner_name} name="outgoing_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처담당자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.outgoing_partner_manager} name="outgoing_partner_manager" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.outgoing_partner_manager_phone} name="outgoing_partner_manager_phone" onChange={(e) => onHypenChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.outgoing_partner_manager_mail} name="outgoing_partner_manager_mail" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">출하처배송지</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="우편번호" value={inputs.outgoing_partner_delivery_post} name="outgoing_partner_delivery_post" onChange={(e) => onChange(e) } style={{ float: 'left', width: '150px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="출하주소" value={inputs.outgoing_partner_delivery_address} name="outgoing_partner_delivery_address" onChange={(e) => onChange(e) } style={{width: '620px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title"></div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="상세주소" value={inputs.outgoing_partner_delivery_address_add} name="outgoing_partner_delivery_address_add" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="outgoing_bigo" value={inputs.outgoing_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '110px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'       
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button" style={{float: 'left'}}>
                      <Button 
                        onClick={ handleOrderRef }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#0067a3", 
                            backgroundColor: "#0067a3",
                            ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                        }} 
                        variant="outlined">
                        수주조회
                      </Button>
                    </div>
                    <div className="modal_button" style={{float: 'left'}}>
                      <Button 
                        onClick={ handleOutgoingRef }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "rgb(62, 152, 243)", 
                            backgroundColor: "rgb(62, 152, 243)",
                            ":hover": { boxShadow: "2px 2px 2px rgb(62, 152, 243)" , backgroundColor: "rgb(62, 152, 243)", borderColor: "rgb(62, 152, 243)"}
                        }} 
                        variant="outlined">
                        출하조회
                      </Button>
                    </div>
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectOrderModalOpen && (<OrderSelectModal
          onClose={() => {
              setSelectOrderModalOpen(false);
          }}
          title={selectmodalTitle}
          openType={'Outgoing'}
          handleOrderClick={handleOrderClick}
          />)}
        {isSelectOutgoingModalOpen && (<OutgoingSelectModal
          onClose={() => {
              setSelectOutgoingModalOpen(false);
          }}
          title={selectmodalTitle}
          handleOutgoingClick={handleOutgoingClick}
          />)}
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default OutgoingRegModal;